import mortgageService from "../../services/mortgage";
import { config } from "../../config.js";
const utmSource = config.source[process.env.VUE_APP_BRAND];

export const mortgageDataModule = {
  namespaced: true,
  state: {
    price: 300000,
    province_id: null,
    income: null,
    expenses: null,
    savings: null,
    interest_type: null,
    criteria: null,
    occupancy: null,
    operation_type: null,
    current_step: null,
    ammount_borrowed: 240000,
  },
  mutations: {
    SET_PRICE: (state, price) => {
      state.price = price;
    },
    SET_PROVINCE_ID: (state, provinceId) => {
      state.province_id = provinceId;
    },
    SET_INCOME: (state, income) => {
      state.income = income;
    },
    SET_EXPENSES: (state, expenses) => {
      state.expenses = expenses;
    },
    SET_SAVINGS: (state, savings) => {
      state.savings = savings;
    },
    SET_INTEREST_TYPE: (state, interestType) => {
      state.interest_type = interestType;
    },
    SET_CRITERIA: (state, criteria) => {
      state.criteria = criteria;
    },
    SET_OCCUPANCY: (state, occupancy) => {
      state.occupancy = occupancy;
    },
    SET_OPERATION_TYPE: (state, operationType) => {
      state.operation_type = operationType;
    },
    SET_CURRENT_STEP: (state, step) => {
      state.current_step = step;
    },
    SET_AMMOUNT_BORROWED: (state, ammountBorrowed) => {
      state.ammount_borrowed = ammountBorrowed;
    },
    SET_MORTGAGE: (state, mortgageData) => {
      state.price = parseInt(mortgageData.price);
      state.province_id = mortgageData.province_id;
      state.income = parseInt(mortgageData.income);
      state.expenses = parseInt(mortgageData.expenses);
      state.savings = parseInt(mortgageData.savings);
      state.interest_type = mortgageData.interest_type;
      state.criteria = mortgageData.criteria;
      state.occupancy = mortgageData.occupancy;
      state.current_step = mortgageData.current_step;
      state.ammount_borrowed = mortgageData.ammount_borrowed;
    },
    CLEAR_ALL: (state) => {
      state.price = 300000;
      state.province_id = null;
      state.income = null;
      state.expenses = null;
      state.savings = null;
      state.interest_type = null;
      state.criteria = null;
      state.occupancy = null;
      state.operation_type = null;
      state.current_step = null;
      state.ammount_borrowed = 240000;
    },
  },
  getters: {
    all: (state) => {
      return state;
    },
    price: (state) => {
      return state.price;
    },
    provinceId: (state) => {
      return state.province_id;
    },
    income: (state) => {
      return state.income;
    },
    expenses: (state) => {
      return state.expenses;
    },
    savings: (state) => {
      return state.savings;
    },
    criteria: (state) => {
      return state.criteria;
    },
    occupancy: (state) => {
      return state.occupancy;
    },
    currentStep: (state) => {
      return state.current_step;
    },
    ammountBorrowed: (state) => {
      return state.ammount_borrowed;
    },
    isFullMortgageData: (state) => {
      return (
        !!state.occupancy &&
        !!state.province_id &&
        !!state.price &&
        !!state.ammount_borrowed
      );
    },
  },
  actions: {
    clearAll(ctx) {
      ctx.commit("CLEAR_ALL");
    },
    async createMortgage({ commit, state, rootState }) {
      const data = {
        client: {
          name: rootState.personalData.name,
          surname: rootState.personalData.surname,
          email: rootState.personalData.email,
          phone: rootState.personalData.phone,
          utm_source: utmSource,
          utm_medium: "web",
          utm_campaign: "listing",
        },
        mortgage: {
          price: state.price,
          ammount_borrowed: state.ammount_borrowed,
          occupancy: state.occupancy,
          province_id: state.province_id,
        },
      };
      commit("ui/SET_LOADING", true, { root: true });
      try {
        await mortgageService.createMortgage(data);
      } catch (error) {
        return {};
      } finally {
        commit("ui/SET_LOADING", false, { root: true });
        commit("ui/SET_STEP", 2, { root: true });
      }
    },
  },
};
